import dayjs from 'dayjs';

type DateRange = {
  from?: string;
  to?: string;
};

export const getNumberOfNights = ({ from, to }: DateRange): number => {
  if (!from || !to) return 0;

  const nights = dayjs(to).diff(dayjs(from), 'day');

  return Math.max(nights, 0);
};
